module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_Black-d9e6a7b51950956e0a50fd0e08acea3b.png";